<div class="heading py-5">
  <h1 class="bold font-curve-large">Subnavigation</h1>
</div>

<section>
  <app-subnavigation-demo></app-subnavigation-demo>
</section>
<code
  class="block"
  [highlight]="codeTemplate"
  [languages]="['html', 'scss', 'css', 'typescript', 'javascript']"
></code>
